import { render, staticRenderFns } from "./materialize_checkboxes.vue?vue&type=template&id=604356f2&"
import script from "./materialize_checkboxes.vue?vue&type=script&lang=js&"
export * from "./materialize_checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./materialize_checkboxes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports